import {api, routes} from "@/plugins/axios";

export function useNews() {
    const createArticle = (organizationSlug, formData) => {
        return api.post(routes.news.create(organizationSlug), formData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const getArticle = (organizationSlug, articleUID) => {
        return api.get(routes.news.get(organizationSlug, articleUID))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const getArticles = (organizationSlug, page, perPage, search, startDate, endDate, filters, tags) => {
        return api.get(routes.news.list(organizationSlug, page, perPage, search, startDate, endDate, filters, tags))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const updateArticle = (organizationSlug, articleUID, formData) => {
        return api.put(routes.news.update(organizationSlug, articleUID), formData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const deleteArticle = (organizationSlug, articleUID) => {
        return api.delete(routes.news.delete(organizationSlug, articleUID))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const getPublicNews = (organizationSlug, page, perPage) => {
        return api.get(routes.news.getPublicNews(organizationSlug, page, perPage))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const getPublicArticle = (organizationSlug, uid) => {
        return api.get(routes.news.getPublicArticle(organizationSlug, uid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const likeArticle = (organizationSlug, articleUID) => {
        return api.post(routes.news.like(organizationSlug, articleUID))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const unlikeArticle = (organizationSlug, articleUID) => {
        return api.delete(routes.news.unlike(organizationSlug, articleUID))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const shareArticle = (organizationSlug, articleUID, payload) => {
        return api.post(routes.news.share(organizationSlug, articleUID), payload)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    return {
        createArticle,
        getArticle,
        getArticles,
        updateArticle,
        deleteArticle,
        getPublicNews,
        getPublicArticle,
        likeArticle,
        unlikeArticle,
        shareArticle
    }
}
